/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Pdfs_AfterthoughtInputs */

const en_why_listening_pdfs_afterthought = /** @type {(inputs: Why_Listening_Pdfs_AfterthoughtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDFs an afterthought`)
};

const es_why_listening_pdfs_afterthought = /** @type {(inputs: Why_Listening_Pdfs_AfterthoughtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los PDF, en segundo plano`)
};

/**
* | output |
* | --- |
* | "PDFs an afterthought" |
*
* @param {Why_Listening_Pdfs_AfterthoughtInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_pdfs_afterthought = /** @type {((inputs?: Why_Listening_Pdfs_AfterthoughtInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Pdfs_AfterthoughtInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_pdfs_afterthought(inputs)
	return en_why_listening_pdfs_afterthought(inputs)
});